import StageVergoedingCharacterImg from "./char-stagevergoeding-default.svg";
import StageVergoedingCharacterExplainingImg from "./char-stagevergoeding-explaining.svg";

export const StageVergoedingCharacter = {
  Default: StageVergoedingCharacterImg,
  Explaining: StageVergoedingCharacterExplainingImg,
};

export default StageVergoedingCharacter;
